import Cookies from 'js-cookie'
// token 标志
const TokenKey = 'admin_token'
// 得到cookie
export function getToken() {
    return Cookies.get(TokenKey)
}

//设置Token
export function setToken(token) {
	//路径在Admin下，期限7天
	return Cookies.set(TokenKey, token, { expires: 7 })
    // return Cookies.set(TokenKey, token, { expires: 7, path: '/admin' })
}
//移除Token
export function removeToken() {
    return Cookies.remove(TokenKey)
}